import React from "react";
import Icon from "@amzn/meridian/icon";
import Tooltip from "@amzn/meridian/tooltip";
import syncTokens from "@amzn/meridian-tokens/base/icon/sync";
import { colorBlue400 } from "@amzn/meridian-tokens/base/color";
import { css } from "emotion";

const blueText = css({
  color: colorBlue400,
});

/**
 * Icon for the "Scanned Previously" badge status shown only in the Overall audit view of
 * multi-segment (CH) shifts — an associate who scanned in an earlier segment and is assumed
 * present in a later, un-scanned one. Blue distinguishes it from green (Scanned) / red (Not
 * Scanned) at a glance.
 */
export default function BlueScannedPreviouslyWithTooltip() {
  return (
    <span className={blueText}>
      <Tooltip position="top" title="Scanned in an earlier segment — assumed present">
        <Icon tokens={syncTokens} />
      </Tooltip>
    </span>
  );
}
